import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { BalanceModel } from 'src/app/models/balance-model';

@Component({
  selector: 'app-total-deposits',
  templateUrl: './total-deposits.component.html',
  styleUrls: ['./total-deposits.component.scss'],
})

export class TotalDepositsComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;

  public accountBalances: BalanceModel;
  public emailMeDisabled: boolean = false;
  public error = null;
  public totalDeposits: any[] = [];

  constructor(
    private balanceService: AccountBalanceService,
    private depositService: DepositService,
    private successMessageService: SuccessMessageService,
    private cgd:ChangeDetectorRef
  ){}

  ngOnInit(): void {
    this.successMessageService.clearMessage();
    this.error = null;

    this.onGetBalance();
    this.onGetTotalDeposits();
  }

  public onGetBalance() 
  {
    this.balanceService.reloadBalance().subscribe(response => {
      if(!!response.result && response.payload) this.balanceService.setBalance(response.payload);
      
      this.balanceService.getBalance().subscribe(
        (response: BalanceModel) => {
          if (response) {
            this.accountBalances = response;
            this.cgd.detectChanges();
          }
        }
      );
      })
  }

  public onGetTotalDeposits() {
    this.totalDeposits = [];
    this.depositService.callGetTotalDeposits().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          var tempDeposits: any = response.payload;
          for (let index in tempDeposits) {
            this.totalDeposits.push(tempDeposits[index]);
          }
        }
      },
      (error) => console.error("Total Deposit Page", error));
  }

  public onEmailMeClicked() {
    this.emailMeDisabled = true;

    this.depositService.callSendTotalDeposits().subscribe(
      (response) => {
        if (response.result == 1) {
          this.content.scrollToTop();
          this.successMessageService.setMessage("An email with all results has been sent.");
        }
      },
      (error) => {
        this.successMessageService.clearMessage();
        this.content.scrollToTop();
        this.error = error;
        this.error.setErrorMessage('Sorry, an error occured processing your report. Please try again');
      }
    )
  }
}
